import { attrs, cx, html, type Html, type Part } from "../html.ts";

export interface SegItem {
  id: string;
  label: Part;
  /** A link target. Without one the item is a button. */
  href?: string;
}

/** `.seg` segmented control from the design. Links mark the current one with aria-current, buttons with aria-pressed. */
export function seg(items: readonly SegItem[], current: string, label: string): Html {
  return html`<div class="seg" role="group" aria-label="${label}">${items.map((i) => {
    const on = i.id === current;
    return i.href !== undefined
      ? html`<a${attrs({ class: cx("seg__i", on && "is-on"), href: i.href, "aria-current": on ? "page" : undefined })}>${i.label}</a>`
      : html`<button${attrs({ class: cx("seg__i", on && "is-on"), type: "button", "aria-pressed": String(on) })}>${i.label}</button>`;
  })}</div>`;
}

/** `.toggle` as a real switch. */
export function toggle(props: { label: string; on: boolean; id?: string }): Html {
  return html`<button${attrs({ class: cx("toggle", !props.on && "is-off"), type: "button", role: "switch", "aria-checked": String(props.on), "aria-label": props.label, id: props.id })}></button>`;
}
